import get from "lodash/get";
import { Store } from "./store";

const retrieskey = "customEnvLoginAttemp";
const customEnvPath = "RaStore.app_settings.ENV";
const customEnvRetries = 4;

export const customENV = (fallback = {}) =>
  get(Store.getAll(), customEnvPath, fallback);

export const resetCustomEnvTries = () => Store.remove(retrieskey);

const resetCustomEnv = (tries) => {
  const message = [
    `Apparently you have tried to login ${tries} times`,
    `You are using a custom backend setup`,
    `If you think a bad backend setup could be the cause of the issue, please try removing the custom setup`,
    `Proceed and remove the custom backend setup?`,
  ].join(".\n");

  if (confirm(message)) {
    Store.removePath(customEnvPath);
    resetCustomEnvTries();
  }
};

export const customEnvLoginAttemp = () => {
  if (customENV(null)) {
    let tries = Store.get(retrieskey) || 0;
    tries++;
    Store.set(retrieskey, tries);

    if (tries > customEnvRetries * 2) resetCustomEnv(Math.floor(tries / 2));
  }
};
